if (!window.__missenceUiTabs) {
  window.__missenceUiTabs = true;
  const PANEL_SWITCH_DURATION_MS = 280;

  const setActiveMissenceTab = (root, trigger, animate = false) => {
    if (!root || !trigger) return;

    const tabKey = trigger.getAttribute('data-missence-ui-tab-trigger');
    const panels = root.querySelector('.missence-comparison__panels');

    root.querySelectorAll('[data-missence-ui-tab-trigger]').forEach((button) => {
      const isActive = button === trigger;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', String(isActive));
    });

    root.querySelectorAll('[data-missence-ui-tab-panel]').forEach((panel) => {
      const isActive = panel.getAttribute('data-missence-ui-tab-panel') === tabKey;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });

    if (animate && panels) {
      panels.classList.remove('is-switching');
      window.requestAnimationFrame(() => {
        panels.classList.add('is-switching');
        window.setTimeout(() => {
          panels.classList.remove('is-switching');
        }, PANEL_SWITCH_DURATION_MS);
      });
    }
  };

  const initMissenceTabs = () => {
    document.querySelectorAll('[data-missence-ui-tabs-root]').forEach((root) => {
      const activeTrigger = root.querySelector('[data-missence-ui-tab-trigger].is-active');
      const firstTrigger = root.querySelector('[data-missence-ui-tab-trigger]');
      setActiveMissenceTab(root, activeTrigger || firstTrigger);
    });

    document.querySelectorAll('.missence-collection-products-section.is-pending').forEach((section) => {
      section.classList.remove('is-pending');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMissenceTabs);
  } else {
    initMissenceTabs();
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-missence-ui-tab-trigger]');
    if (!trigger) return;

    const root = trigger.closest('[data-missence-ui-tabs-root]');
    if (!root) return;

    if (trigger.classList.contains('is-active')) return;

    setActiveMissenceTab(root, trigger, true);
  });
}
